import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
// import { Factory, Sun, ShieldCheck, PaintBucket } from 'lucide-react'; // Removed
import { SmokingFactory, RotatingSun, PulsingShield, TiltingBucket } from '../components/AnimatedIcons'; // Added
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ShowcaseSection from '../components/ShowcaseSection';
import AboutSection from '../components/AboutSection';
import WhyUsSection from '../components/WhyUsSection';
import Footer from '../components/Footer';

const Home = () => {
    const location = useLocation();
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start 80%", "end 90%"]
    });

    const scaleY = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });

    useEffect(() => {
        if (location.state?.target) {
            const element = document.getElementById(location.state.target);
            if (element) {
                // Short timeout to ensure DOM is fully ready
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location]);

    return (
        <div className="bg-black min-h-screen font-sans selection:bg-white selection:text-black">
            <Navbar />

            <main>
                <Hero />

                <AboutSection />

                <div id="services" ref={containerRef} className="relative">
                    {/* Roadmap Track (Background) */}
                    <div className="absolute left-1/2 top-0 bottom-32 w-[1px] bg-neutral-800 -translate-x-1/2 hidden md:block" />

                    {/* Roadmap Progress Line (Live) */}
                    <motion.div
                        className="absolute left-1/2 top-0 bottom-32 w-[1px] bg-gradient-to-b from-blue-500 via-white to-blue-500 -translate-x-1/2 hidden md:block origin-top"
                        style={{ scaleY }}
                    />

                    {/* 1. Coperture */}
                    <ShowcaseSection
                        title="Coperture Industriali e Civili"
                        subtitle="Materiali di Nuova Generazione"
                        description="Lavoriamo con materiali di nuova generazione per realizzare tetti e coperture, fornendovi isolamento termico, impermeabilizzazione e massima resistenza alle condizioni atmosferiche. Sia a livello industriale che privato, offriamo soluzioni su misura per praticamente tutte le esigenze architettoniche."
                        imageWebp="/assets/video/hero/foto_1.webp"
                        imageFallback="/assets/video/hero/foto_1.webp"
                        align="left"
                        index={0}
                        Icon={SmokingFactory}
                    />

                    {/* 2. Fotovoltaico */}
                    <ShowcaseSection
                        title="Impianti Fotovoltaici"
                        subtitle="Energia Rinnovabile"
                        description="Trasformiamo il vostro tetto in una fonte di reddito e risparmio. Progettiamo e installiamo impianti fotovoltaici, integrando perfettamente i pannelli con la struttura del tetto per ottimizzare l'efficienza energetica e ridurre i costi delle utenze."
                        imageWebp="/assets/video/hero/foto_2.webp"
                        imageFallback="/assets/video/hero/foto_2.webp"
                        align="right"
                        index={1}
                        Icon={RotatingSun}
                    />

                    {/* 3. Amianto */}
                    <ShowcaseSection
                        title="Rimozione e Smaltimento Amianto"
                        subtitle="Sicurezza Certificata"
                        description="La sicurezza è la nostra priorità. Abbiamo la certificazione di sicurezza per le lastre in cemento-amianto (eternit). Ci occupiamo di tutto il lavoro burocratico e tecnico per sostituire i vecchi materiali dannosi con nuove coperture certificate e sicure."
                        imageWebp="/assets/video/hero/foto_3.webp"
                        imageFallback="/assets/video/hero/foto_3.webp"
                        align="left"
                        index={2}
                        Icon={PulsingShield}
                    />

                    {/* 4. Ristrutturazione */}
                    <ShowcaseSection
                        title="Ristrutturazione Interni"
                        subtitle="Chiavi in Mano"
                        description="Dalla posa di cappotti termici al rifacimento impianti, fino all'arredamento d'interni. Coordiniamo ogni maestranza per garantirti un unico interlocutore, tempi certi e un risultato che rifletta esattamente il tuo stile."
                        imageWebp="/assets/video/hero/foto_4.webp"
                        imageFallback="/assets/video/hero/foto_4.webp"
                        align="right"
                        index={3}
                        Icon={TiltingBucket}
                    />
                </div>

                <WhyUsSection />

            </main>

            <Footer />
        </div>
    );
};

export default Home;
